import type { ReactNode } from 'react';
import { Button } from '@/components/ui-kit/button';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface AdminTopbarProps {
  onMenuClick: () => void;
  /** Optional right-side action — used by AdminShell to inject a
      route-specific control (e.g. the dashboard's Quick Actions menu). */
  action?: ReactNode;
}

export function AdminTopbar({ onMenuClick, action }: AdminTopbarProps) {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const sectionTitle = (() => {
    if (pathname.includes('/admin/templates')) {
      if (pathname.includes('/new')) return t('ADMIN_TOPBAR_SECTIONS_NEWTEMPLATE');
      if (pathname.includes('/edit')) return t('ADMIN_TOPBAR_SECTIONS_EDITTEMPLATE');
      if (pathname.includes('/builder')) return t('ADMIN_TOPBAR_SECTIONS_TEMPLATEBUILDER');
      return t('ADMIN_TOPBAR_SECTIONS_TEMPLATES');
    }
    if (pathname.includes('/admin/analytics')) return t('ADMIN_TOPBAR_SECTIONS_ANALYTICS');
    if (pathname.includes('/admin/users')) return t('ADMIN_TOPBAR_SECTIONS_USERS');
    if (pathname.includes('/admin/settings')) return t('ADMIN_TOPBAR_SECTIONS_SETTINGS');
    return t('ADMIN_TOPBAR_SECTIONS_DASHBOARD');
  })();

  return (
    <div className="sticky md:hidden top-0 z-40 h-16 border-b border-border bg-[hsl(var(--bg))] backdrop-blur-sm">
      <div className="flex h-full items-center justify-between px-1 pr-3 lg:pr-6 lg:px-6">
        {/* Left: Mobile menu + Section title */}
        <div className="flex items-center gap-1 md:gap-4">
          <Button variant="ghost" size="icon" onClick={onMenuClick} className="md:hidden h-9 w-9">
            <Menu className="h-5 w-5" />
          </Button>
          <h1 className="text-base md:text-lg font-semibold text-[hsl(var(--fg))] font-heading">
            {sectionTitle}
          </h1>
        </div>

        {/* Center: Search (hidden on mobile, visible on desktop) */}
        {/* <div className="hidden md:flex flex-1 max-w-md mx-8">
          <div className="relative w-full">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-globe-grey" />
            <Input
              type="search"
              placeholder={t('ADMIN_TOPBAR_SEARCHPLACEHOLDER')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-9 h-9"
            />
          </div>
        </div> */}

        {/* Right: route-specific action */}
        <div className="flex items-center gap-2">{action}</div>
      </div>
    </div>
  );
}
